import qs, { type IStringifyOptions } from 'qs';

import { convertKeysToSnake } from './convert-keys';

type TTransformRequestConstraints = Record<string, unknown> | ReadonlyArray<unknown>;

export function paramsSerializer<T extends TTransformRequestConstraints>(params: T, options?: IStringifyOptions) {
    return qs.stringify(
        convertKeysToSnake(params),
        {
            skipNulls  : true,
            arrayFormat: 'comma',
            encode     : false,
            ...options
        }
    );
}
